import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core';

const ClientAnnouncementSettings = ({
  announcement,
  handleClientAnnouncement,
}) => (
  <Card style={{ borderTop: '4px solid #3fcada' }}>
    <CardHeader
      title="Client entry message"
      subheader="Show a branded message after clients log in or launch the app while already signed in."
    />
    <Divider />
    <CardContent>
      <Formik
        enableReinitialize
        initialValues={{
          enabled: Boolean(announcement && announcement.enabled),
          title: announcement.title || '',
          message: announcement.message || '',
        }}
        validationSchema={Yup.object().shape({
          enabled: Yup.boolean().required(),
          title: Yup.string().max(
            120,
            'The title cannot exceed 120 characters.'
          ),
          message: Yup.string()
            .max(2000, 'The message cannot exceed 2,000 characters.')
            .test(
              'required-when-enabled',
              'Enter a message before switching it on.',
              function validateEnabledMessage(value) {
                return !this.parent.enabled || Boolean(value && value.trim());
              }
            ),
        })}
        onSubmit={handleClientAnnouncement}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormControlLabel
                  control={(
                    <Switch
                      checked={values.enabled}
                      color="primary"
                      name="enabled"
                      onChange={handleChange}
                    />
                  )}
                  label={values.enabled ? 'Message is active' : 'Message is off'}
                />
                <Typography variant="caption" color="textSecondary" display="block">
                  Turning this off keeps the draft below but stops showing it
                  to clients.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.title && errors.title)}
                  fullWidth
                  helperText={
                    (touched.title && errors.title)
                    || `${values.title.length}/120 characters - leave empty for no title`
                  }
                  label="Title (optional)"
                  name="title"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  placeholder="Example: Aviso importante"
                  value={values.title}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.message && errors.message)}
                  fullWidth
                  helperText={
                    (touched.message && errors.message)
                    || `${values.message.length}/2000 characters`
                  }
                  label="Message shown to clients"
                  multiline
                  name="message"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  placeholder="Example: Hoje estamos disponiveis ate as 20h."
                  rows={5}
                  value={values.message}
                  variant="outlined"
                />
              </Grid>
              {values.message.trim() && (
                <Grid item xs={12}>
                  <Box
                    bgcolor="#f5fcfd"
                    border="1px solid #b8eef3"
                    borderRadius={8}
                    p={2}
                  >
                    <Typography
                      color="primary"
                      gutterBottom
                      variant="overline"
                    >
                      Client preview
                    </Typography>
                    {values.title.trim() && (
                      <Typography
                        color="primary"
                        gutterBottom
                        variant="h5"
                      >
                        {values.title}
                      </Typography>
                    )}
                    <Typography style={{ whiteSpace: 'pre-line' }}>
                      {values.message}
                    </Typography>
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  SAVE CLIENT MESSAGE
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </CardContent>
  </Card>
);

ClientAnnouncementSettings.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  announcement: PropTypes.object.isRequired,
  handleClientAnnouncement: PropTypes.func.isRequired,
};

export default ClientAnnouncementSettings;
